import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import vw from 'styles/utils';
// import media from 'styles/media';

function ImageThumbnail(props) {
  const { src, title, time, url } = props;

  return (
    <Root href={url} target="_blank">
      <img src={src} alt="thumbnail"/>
      <p>{title}</p>
      <PostTime>{time}</PostTime>
    </Root>
  )
}

ImageThumbnail.propTypes = {
  src: PropTypes.any,
  title: PropTypes.string
}

const Root = styled.div`
  cursor: pointer;

  ${vw('margin-left', 0, 10)}
  ${vw('margin-right', 0, 10)}

  &:hover {
    > p {
      color: #3398DC;
    }
  }

  > img {
    width: 100%;
    
    ${vw('height', 140, 130, 200)}
    ${vw('margin-bottom', 3, 6, 10)}
  }

  > p {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 500;
    color: #252525;
    transition: all 0.25s;

    ${vw('font-size', 10, 14)}
    ${vw('line-height', 18, 25)}
  }
`;

const PostTime = styled.h6`
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  color: #757575;
`;

export default ImageThumbnail
